<template lang="pug">
k-page.program.post( :key='postData.id' ref='page' )
  template( v-if=`layout === 'suave'` )
    k-browser-content
  template( v-else )
    d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
    k-hero
    w-go-down
    k-main( :title='title' )
      section.description( v-html='content' )
      content-section(
        v-if='!postData.hide_programs'
        :title='episodesTitle'
        :coming='postData.release_date'
        :hide-coming='postData.hide_coming'
        :labels='postData.episode_labels'
        :episodes='episodes'
      )
      content-section(
        :title='archivesTitle'
        :episodes='archives'
        :labels='postData.episode_labels'
        :show-empty='false'
      )
      comments
    .bottom-spacer
</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import he from 'he'
import DMainImage from '@/displays/d-main-image'
import KBrowserContent from '@/blocks/k-browser-content'
import KPage from '@/blocks/k-page'
import KHero from '@/blocks/k-hero'
import KMain from '@/blocks/k-main'
import WGoDown from '@/widgets/w-go-down'
import ContentSection from '@/components/content-section'
import Comments from '@/components/comments'
import { Page } from '@/mixins'

export default {
  name: 'ProgramPage',
  mixins: [ Page ],
  components: {
    DMainImage,
    KBrowserContent,
    KPage,
    KHero,
    KMain,
    WGoDown,
    ContentSection,
    Comments
  },
  props: [ 'post' ],
  data() {
    return {
      promos: [],
    }
  },
  created() {},
  mounted() {
    window.setTimeout(() => {
      this.promos = this.promo_reel
      this.loading = false
      if ( this.promos && this.promos.length ) {
        this.setHero({
          name: 'video-preview',
          data: {
            content: this.promos[0],
            series: this.promos
          }
        })
      }
    }, 1500 )
    this.loadMenu()
  },
  methods: {
    ...mapActions([ 'setHero', 'updateHeroData', 'pushMenu' ]),
    loadMenu() {
      // TODO: get releases
      const menu = {
        name: this.postData.path,
        header: {
          title: 'On This Page'
        },
        items: []
      }
      if ( this.episodes ) {
        for ( const item of this.episodes ) {
          menu.items.push({
            title: item.title.rendered,
            caption: item.caption.rendered,
            thumb: item.thumbnail,
            url: item.path,
            type: 'media',
            flat: true,
          })
        }
      }
      // TODO: build menu
      // TODO: pushMenu
      if ( menu.items ) {
        this.pushMenu( menu )
      }
    }
  },
  computed: {
    ...mapGetters([ 'layout' ]),
    promo_reel() {
      return this.postData.promo_reel || []
    },
    episodes() {
      return this.postData.releases || []
    },
    episodesTitle() {
      return this.postData.title_releases || 'Programmes'
    },
    archives() {
      return this.postData.archives || []
    },
    archivesTitle() {
      return this.postData.title_archives || 'From the Archives'
    },
    classes() {
      // return { small: !this.loading && !this.promos.length }
      return {}
    }
  },
  watch: {
    $route( to, from ) {
      this.promos = []
      this.storedPost = Object.assign( {}, this.$store.state.post )
      this.$nextTick(() => {
        document.title = he.decode( this.title + ' | ' + this.siteTitle )
      })
      window.setTimeout(() => {
        this.promos = this.promo_reel || []
        if ( this.promos && this.promos.length ) {
          this.setHero({
            name: 'video-preview',
            data: {
              content: this.promos[0],
              series: this.promos
            }
          })
        }
      }, 1500 )
    }
  }
}
</script>

<style lang="scss">
.program {
}
</style>
